{partitionAndSort} = require('../../utils')

module.exports = ($scope, $uibModal, Api, User) ->
  $scope.comment = undefined
  $scope.newName = undefined

  $scope.showExcluded = !User.hasTaggingConfigs()

  $scope.numWorkflowSteps = (workflow_id) ->
    return $scope.allWorkflowSteps[workflow_id].length

  $scope.deleteWorkflowStep = (step) ->
    if Object.keys($scope.allSteps).length <= 1
      alert 'Sorry—you cannot delete the last step in a project.'
      return  # abort

    if not confirm 'Are you sure you want to remove this step?'
      return  # abort

    new Api.WorkflowStep({id: step.id}).$delete().then ->
      delete $scope.allSteps[step.id]
      $scope.allWorkflowSteps[step.workflow] =
        (s for s in $scope.allWorkflowSteps[step.workflow] when s.id != step.id)
      if $scope.numWorkflowSteps(step.workflow) == 0
        new Api.Workflow({id: step.workflow}).$delete().then ->
          $scope.setWorkflows (w for w in $scope.workflows when w.id != step.workflow)
          return
    return

  $scope.toggleSearchVariations = () ->
    $scope.isSearchVariationsCollapsed = !$scope.isSearchVariationsCollapsed

  _getSearchWorkers = (step) ->
    new Api.WorkflowStepIteration.query({project: $scope.project.id }).$promise.then (response) ->
      $scope.workflowStepIterations = partitionAndSort(response, 'workflow_step', 'id')
      searchIds = (iteration.search for iteration in $scope.workflowStepIterations[step.id])
      new Api.SearchWorker.query({search: searchIds}).$promise.then (response) ->
        $scope.searchWorkers = response

  $scope.showSearchVariations = () ->
    $scope.isSearchVariationsShown = true
    _getSearchWorkers( $scope.step )

  $scope.totalResults = (iteration) ->
    total = 0
    if iteration && $scope.searchWorkers
      iterationSearchWorkers = (search for search in $scope.searchWorkers when search.search == iteration.search)
      for search in iterationSearchWorkers
        total += search?.results_available
    return total

  $scope.isSearchVariationsCollapsed = false
